import { useContext } from 'react'
import jwtDecode from 'jwt-decode'

import AuthContext from './context'
import authStorage from './storage'

const useAuth = () => {
  const { user, setUser } = useContext(AuthContext)

  const login = async (authToken) => {
    const user = jwtDecode(authToken)
    setUser(user)
    await authStorage.storeToken(authToken)
  }

  const logout = async () => {
    setUser(null)
    await authStorage.removeToken()
  }

  return { utente: user?.admin ? user?.admin : user?.cliente, login, logout }
}

export default useAuth
